/* ----------------------------------------------------------------------------
   LBM STICKY BAR
   ----------------------------------------------------------------------------
   Prestige 標準のカート追加バーは「購入フォームを通り過ぎた かつ フッターが
   見えていない」ときだけ表示される。商品ページの下に関連商品などが続く
   レイアウトを前提にした条件で、この店のスマホ表示では成立せず一度も出ない。

   そこでスマホ幅のときだけ、よくあるカート追加バーと同じ条件に置き換える。
     ・商品名を通り過ぎたら表示対象にする（開いた直後に出るのを防ぐ）
     ・本体のカートボタンが画面に入っている間は引っ込める（ボタンの二重表示を防ぐ）

   あわせて、色やサイズの選択肢がある商品では、バーのボタンを
   「種類を選ぶ」に差し替えて選択欄までスクロールさせる。
   選ばないまま最初の種類がカートに入ってしまう事故を防ぐため。
   種類が1つだけの商品は、そのままカートに追加できる。

   PC幅ではこのファイルは何もしない（テーマ標準の挙動のまま）。
   ------------------------------------------------------------------------- */

(function () {
  'use strict';

  var MOBILE_MAX_WIDTH = 699;      // この幅以下でだけ独自制御する（テーマの分岐と揃えている）
  var CHOOSE_LABEL = '種類を選ぶ'; // 選択肢がある商品で出すボタンの文言
  var SCROLL_OFFSET_RATIO = 0.3;   // 選択欄を画面の上から何割の位置に置くか（ヘッダーを避ける）

  // 選択肢がある商品では、バーのボタンを「種類を選ぶ」に差し替える
  function setupChooseButton(bar) {
    // variant-picker 要素は、選択肢が実際にある商品にだけ出力される
    var picker = document.querySelector('.product-info variant-picker');
    if (!picker) return;
    if (bar.querySelector('.lbm-sticky-choose-button')) return;

    var target = picker.closest('.product-info__block-item') || picker;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'button lbm-sticky-choose-button';
    button.textContent = CHOOSE_LABEL;

    button.addEventListener('click', function () {
      // ヘッダーに隠れないよう、画面のやや上寄りに選択欄が来る位置まで動かす
      var top = window.scrollY
        + target.getBoundingClientRect().top
        - window.innerHeight * SCROLL_OFFSET_RATIO;

      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });

      // スクロールし終えたころに選択欄へフォーカスを当てて、視線を誘導する
      var control = picker.querySelector('button.select, select, input:not([type="hidden"])');
      if (control) {
        setTimeout(function () {
          try { control.focus({ preventScroll: true }); } catch (error) {}
        }, 600);
      }
    });

    bar.classList.add('lbm-sticky-choose');
    bar.appendChild(button);
  }

  function setupVisibility(bar) {
    var title = document.querySelector('.product-info__block-item[data-block-type="title"]');
    var mainBuyButton = document.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');
    if (!title || !mainBuyButton) return;

    function update() {
      if (window.innerWidth > MOBILE_MAX_WIDTH) {
        bar.classList.remove('lbm-sticky-on');
        return;
      }

      // 商品名が画面の上に抜けたか
      var pastTitle = title.getBoundingClientRect().bottom < 0;

      // 本体のカートボタンが画面内にあるか
      var rect = mainBuyButton.getBoundingClientRect();
      var buyButtonVisible = rect.bottom > 0 && rect.top < window.innerHeight;

      bar.classList.toggle('lbm-sticky-on', pastTitle && !buyButtonVisible);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function init() {
    document.querySelectorAll('product-sticky-bar').forEach(function (bar) {
      setupChooseButton(bar);
      setupVisibility(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();